import { render, staticRenderFns } from "./order-item-table.vue?vue&type=template&id=54025958&scoped=true&"
import script from "./order-item-table.ts?vue&type=script&lang=ts&"
export * from "./order-item-table.ts?vue&type=script&lang=ts&"
import style0 from "./order-item-table.scss?vue&type=style&index=0&id=54025958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54025958",
  null
  
)

export default component.exports